import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaoTomeandPrincipe: Country = {
    identifier: "SaoTomeandPrincipe",
    name: "Sao Tome and Principe",
    countryCode: "ST",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇸🇹",
    svgPath: "m 495.73075,458.5514 -0.104,0.073 -0.124,-0.062 -0.033,-0.111 0.16,-0.214 0.076,-0.053 0.063,0.045 0.038,0.059 0.005,0.086 -0.081,0.177 z m -2.144,4.034 -0.29,0.204 -0.104,-0.053 -0.064,-0.142 -0.081,-0.307 0.026,-0.147 0.131,-0.168 0.285,-0.167 0.171,-0.012 0.176,0.22 0.001,0.229 -0.251,0.343 z",
}
